export default __webpack_public_path__ + "static/media/pills.f3539fa8.svg";